/**
 * created by xcc on 2022/2/21
 * 媒体管理新增页面
 */

import React from 'react';
import {
    Button,
    Upload,
    Select,
    Modal,
    Input,
    Row,
    Col,
    Icon,
    Table,
    Checkbox, Pagination, InputNumber, Divider, Radio
} from "antd";
import "./MediaAdminister.css";
import {message} from "../../sysManagement/utils/sysManagementUtils";
import ScrollBars from "react-custom-scrollbars";
import DeptTree from "./DeptTree";
import {
    getDeptUserData,
    getDeptUser,
    getMediaSortData,
    mediaAdministerAdd,
    mediaAdministerUpdate
} from "../actions/mediaAdminister";
import BaseComponent from "../../../base/BaseComponent";
import {uuid} from "../../../utils";
import $ from "jquery";
import SelectUserModal from "../../newUserManagement/components/SelectUserModal";


const {TextArea, Search} = Input;
const {Option} = Select;
export default class MediaAdd extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            //新增媒体
            name: "", //媒体名称
            mediaTypeCode: undefined, //媒体类型
            rmType: 0,
            deptId: "", //所属部门
            description: "", //媒体描述
            mediaLogo: "", //媒体logo
            sort: "", //媒体排序
            id: "",
            //选择管理员
            page: 1,
            size: 10,
            total: 0,
            managerVisible: false,
            keywords: "",
            deptUserList: [],
            useDeptUserList: [],  //选中暂存的数据
            checkedAll: false,
            loadKey: uuid(),
            //选择部门
            deptVisible: false,
            deptName: [],
            newData: [], //确定暂存的数据
            hideOnSinglePage: true,
            indeterminate: false,
            currentMedia: {},
            bindUsers: false,//是否显示操纵 绑定用户
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.props.onRef(this);
        window.top.currentUser.checked = true;
        this.setState({
            deptId: window.top.currentUser.deptIds[0], //当前用户部门id
            deptName: [window.top.currentUser.deptList[0].name],  //当前用户部门名称
            newData: [window.top.currentUser]  //当前用户信息
        }, () => {
            this.getDeptUser();
        })
    }

    selectAdministrator(data) {
        this.setState({deptId: data.deptId, bindUsers: true, newData: data?.chooseUsers, currentMedia: data}, () => {
            this.selectManager(true)
        });
    }

    getItem(record) {

        let useDeptUserList = [];
        record.chooseUsers && record.chooseUsers.length > 0 && record.chooseUsers.forEach(i => {
            useDeptUserList.push({id: i.id, name: i.name, checked: true})
        });

        this.setState({
            currentMedia: record,
            name: record.name, //媒体名称
            mediaTypeCode: record.mediaTypeCode, //媒体类型
            deptId: record.deptId, //所属部门
            deptName: [record.deptName],
            description: record.description, //媒体描述
            mediaLogo: record.mediaLogo, //媒体logo
            sort: record.sort, //媒体排序
            id: record.id,
            newData: useDeptUserList,
            rmType: record.rmType
        })
    }

    getDeptUser(deptId) {
        let params = {
            start: this.state.page,
            size: this.state.size,
            deptIds: deptId ? [deptId] : window.top.currentUser.deptIds
        };
        if (this.state.keywords) {
            params.accountOrName = this.state.keywords;
        }
        getDeptUserData(params, (res) => {
            let data = res.data;
            let deptUserList = [];
            let total = 0;
            if (data.length > 0) {
                deptUserList = data;
                total = res.count;
                deptUserList.forEach(item => {
                    item.checked = false;
                    //数据暂存
                    this.state.useDeptUserList.forEach((i, index) => {
                        if (item.id === i.id) {
                            item.checked = true;
                            // 是因为解决编辑值提供的id,借用已有数据显示NAME
                            this.state.useDeptUserList[index] = item;
                        }
                    })
                })
                let userIds = [];
                this.state.useDeptUserList && this.state.useDeptUserList.length > 0 && this.state.useDeptUserList.forEach(item => {
                    userIds.push(item.id);
                })
                this.state.checkedAll = !!deptUserList.every(val => userIds.includes(val.id));
            }
            //半全选问题
            // this.state.indeterminate = !(deptUserList.every(item => item.checked === false) || !deptUserList.every(item => item.checked));
            this.state.hideOnSinglePage = total <= 10;
            this.setState({
                deptUserList,
                total
            }, () => {
                $('.ant-pagination-options-quick-jumper').find("input").val("");
            });
        });
    }

    checkedAllChange(checked) {
        if (checked) {
            this.state.deptUserList.forEach(item => {
                item.checked = checked;
                let num = 0;
                if (this.state.useDeptUserList.length > 0) {
                    this.state.useDeptUserList.forEach((Item) => {
                        if (item.id !== Item.id) {
                            num++
                        }
                    })
                    if (num === this.state.useDeptUserList.length) {
                        this.state.useDeptUserList.push(item)
                    }
                } else {
                    this.state.useDeptUserList.push(item)
                }
            });
        } else {
            this.state.deptUserList.forEach(item => {
                item.checked = checked;
                this.state.useDeptUserList.forEach((Item, index) => {
                    if (item.id === Item.id) {
                        this.state.useDeptUserList.splice(index, 1)
                    }
                })
            })
        }
        this.setState({})
    }

    simpleCheckedChange(record) {
        if (!record.checked) {
            let aNum = 0;
            if (this.state.useDeptUserList.length > 0) {
                this.state.useDeptUserList.forEach((Item) => {
                    if (record.id !== Item.id) {
                        aNum++
                    }
                })
                if (aNum === this.state.useDeptUserList.length) {
                    this.state.useDeptUserList.push(record)
                }
            } else {
                this.state.useDeptUserList.push(record)
            }
        } else {
            this.state.useDeptUserList.forEach((item, index) => {
                if (item.id === record.id) {
                    this.state.useDeptUserList.splice(index, 1)
                }
            })
        }
        record.checked = !record.checked;
        let numMax = this.state.deptUserList.length;
        let num = 0;
        this.state.deptUserList.forEach((item) => {
            if (item.checked === false) {
                this.state.checkedAll = false;
            } else {
                num++;
            }
        });
        if (numMax === num) {
            this.state.checkedAll = true;
        }
        this.setState({});
    }

    paginationOnChange(page, pageSize) {
        this.scrollBars && this.scrollBars.scrollTop();
        this.state.page = page;
        this.state.size = pageSize;
        this.getDeptUser(this.state.deptId);
    }

    /**
     * 渲染
     */
    render() {
        let isSys = this.props.isSys;
        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'}/>
            </div>
        );
        const upload = {
            name: "file",
            listType: "picture-card",
            accept: '.png,.jpg,.jpeg',
            showUploadList: false,
            beforeUpload: (file) => {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
                if (!isJpgOrPng) {
                    message.error('暂不支持该文件类型，请上传jpg、jpeg、png类型文件！');
                }
                const isLt2M = file.size / 1024 / 1024 < 20;
                if (!isLt2M) {
                    message.error('图片大小必须小于20MB！');
                }
                return isJpgOrPng && isLt2M;
            },
            customRequest: ({file}) => {
                let url = "/storage/uploadFile";
                let fd = new FormData();
                fd.append("file", file);
                this.request({
                    url,
                    body: fd,
                    method: "post",
                    contentType: "upload",
                    callBack: (file) => {
                        let that = this;
                        if (file) {
                            let mediaLogo = file.path ? file.path : null;
                            that.setState({
                                mediaLogo,
                                loading: false,
                            })
                        }
                    },
                    errorCallBack: () => {

                    },
                    serverVerify: {
                        serverErrorCallBack: () => {

                        }
                    }
                });
            }
        };
        const columns = [];
        if (!this.state.bindUsers) {
            columns.push({
                title: (() => {
                    let checkedAll = this.state.deptUserList.length ? this.state.deptUserList.every(item => item.checked) : false;
                    let checkedLength = this.state.deptUserList.length ? this.state.deptUserList.filter(item => item.checked).length : 0
                    let indeterminate = this.state.deptUserList.length && checkedLength > 0 && checkedLength < this.state.deptUserList.length;
                    return (
                        <Checkbox checked={checkedAll} indeterminate={indeterminate} onChange={(e) => {
                            this.checkedAllChange(e.target.checked);
                        }}/>
                    )
                })(),
                align: 'center',
                width: 50,
                key: "checked",
                render: (record) => {
                    return (
                        <div>
                            <Checkbox checked={record.checked} onChange={() => {
                                this.simpleCheckedChange(record);
                            }}/>
                        </div>
                    )
                }
            })
        }
        columns.push({
                title: '姓名',
                dataIndex: 'name',
                key: 'name',
                ellipsis: true,
            },
            {
                title: '账号',
                dataIndex: 'account',
                key: 'account',
                ellipsis: true,
            }, {
                title: '部门',
                key: 'deptName',
                ellipsis: true,
                render: (record) => {
                    let deptNames = [];
                    record.deptList.length && record.deptList.forEach(item => {
                        deptNames.push(item.name);
                    });
                    return (

                        <div style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>{deptNames.join("，")}</div>
                    )
                }
            });

        if (this.state.bindUsers) {
            columns.push({
                title: '操作',
                dataIndex: 'option',
                render: (text, record) => {

                    let currentUser = {
                        userId: record.id,
                        userName: record.name,
                        vsbUserAccount: record?.vsbUserInfo?.vsbUserAccount,
                        vsbUserName: record?.vsbUserInfo?.vsbUserName
                    };
                    return (
                        <div style={{cursor: "pointer", color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}} onClick={() => {
                            this.selectUserModal.show(true,this.state.currentMedia, currentUser, () => {
                                if (this.state.bindUsers) {
                                    this.getNewDeptUser();
                                } else {
                                    this.getDeptUser(this.state.deptId);
                                }
                            });

                        }}>
                            {record.vsbUserInfo?<span>{'已绑定'+record.vsbUserInfo.vsbUserName}</span>:<span>绑定网站用户</span>}
                        </div>

                    )
                }
            })
        }

        if (!isSys && !this.state.bindUsers) {
            columns.splice(3, 1);
        }
        let pagination = {
            onChange: (page, pageSize) => this.paginationOnChange(page, pageSize),
            onShowSizeChange: (page, pageSize) => {
                this.state.hideOnSinglePage = false;
                this.paginationOnChange(page, pageSize);
            },
            defaultCurrent: 1,
            defaultPageSize: 10,
            current: this.state.page,
            pageSize: this.state.size,
            total: this.state.total,
            showTotal: (total) => `共 ${total} 条`,
            showQuickJumper: true, //快速跳转至某一页
            showSizeChanger: true,	//是否可以改变 pageSize
            hideOnSinglePage: this.state.hideOnSinglePage
        };
        let accountNames = [];
        this.state.newData.length > 0 && this.state.newData.forEach(item => {
            if (item.checked) {
                accountNames.push(item.name);
            }
        })
        return (
            <div style={{padding: 20}}>
                {/*新增弹窗*/}
                <Modal
                    title={this.props.title}
                    visible={this.props.addVisible}
                    width={800}
                    height={572}
                    zIndex={500}
                    onCancel={() => {
                        this.props.onCancelAdd();
                    }}
                    maskClosable={false}
                    centered
                    footer={
                        <div style={{textAlign: "center"}}>
                            <Button onClick={() => {
                                this.props.onCancelAdd();
                            }}>取消</Button>
                            <Button type={"primary"} onClick={() => {
                                this.saveMedia()
                            }}>确定</Button>
                        </div>
                    }
                >
                    <div>
                        <Row>
                            <div style={{padding: 10}}>
                                <Col span={3}>
                                    <div className={'myMediaTitle'}><span
                                        style={{color: 'red', position: 'absolute', top: 3, left: 10}}>*</span>媒体名称：
                                    </div>
                                </Col>
                                <Col span={20}>
                                    <Input placeholder={"最长50个字符"} className={'mediaAdministerContent'}
                                           value={this.state.name}
                                           maxLength={50}
                                           onChange={(e) => {
                                               this.setState({name: e.target.value.trim()})
                                           }}/>
                                    <style>{`.ant-input{border: 1px solid #EEF2FB;}`}</style>
                                </Col>
                            </div>
                        </Row>
                        <Row>
                            <div style={{padding: 10}}>
                                <Col span={3}>
                                    <div className={'myMediaTitle'}><span
                                        style={{color: 'red', position: 'absolute', top: 3, left: 10}}>*</span>媒体类型：
                                    </div>
                                </Col>
                                <Col span={20}>
                                    <Select className={'mediaAdministerContent'}
                                            placeholder={"请选择"}
                                            disabled={!!this.state.id}
                                            value={this.state.mediaTypeCode}
                                            style={{width: '100%'}}
                                            onChange={(e) => {
                                                this.state.mediaTypeCode = e;
                                                this.setState({})
                                            }}>
                                        {this.props.mediaPlatformNoAll && this.props.mediaPlatformNoAll.length > 0 && this.props.mediaPlatformNoAll.map((item, i) => {
                                            return (
                                                <Option key={i} value={item.mediaTypeCode}>{item.mediaTypeName}</Option>
                                            )
                                        })}
                                    </Select>
                                    <style>{`.mediaAdministerContent .ant-select-selection{border: 1px solid #EEF2FB; background-color: rgba(246, 248, 253, 0.39);}`}</style>
                                </Col>
                            </div>
                        </Row>
                        {
                            this.state.mediaTypeCode === "rmapp" ?
                                <Row>
                                    <div style={{padding: 10}}>
                                        <Col span={3}>
                                            <div className={'myMediaTitle'}><span
                                                style={{color: 'red', position: 'absolute', top: 3, left: -4}}>*</span>融媒号类型：
                                            </div>
                                        </Col>
                                        <Col span={20}>
                                            <Radio.Group style={{lineHeight: "37px"}} value={this.state.rmType}
                                                         onChange={(e) => {
                                                             this.setState({
                                                                 rmType: e.target.value,
                                                                 mediaLogo: ""
                                                             })
                                                         }}>
                                                <Radio style={{marginRight: 40}} value={0} key={"dept"}>机构号</Radio>
                                                <Radio style={{marginRight: 40}} value={1} key={"person"}>达人号</Radio>
                                            </Radio.Group>
                                        </Col>
                                    </div>
                                </Row> : null
                        }
                        <Row>
                            <div style={{padding: 10, position: "relative"}}>
                                <Col span={3}>
                                    <div className={'myMediaTitle'}><span
                                        style={{color: 'red', position: 'absolute', top: 3, left: 10}}>*</span>所属部门：
                                    </div>
                                </Col>
                                <Col span={20}>
                                    <Select className={'mediaAdministerContent'}
                                            placeholder={"请选择"}
                                            value={this.state.deptName}
                                            style={{width: '100%'}}
                                            open={false}
                                            disabled={!!this.state.id}
                                            showArrow={false}
                                            onDropdownVisibleChange={() => {
                                                if (this.props.isSys === "true") {
                                                    this.props.departAllList.length && this.props.departAllList.forEach(item => {
                                                        item.checked = this.state.deptId === item.id;
                                                    });
                                                    this.deptTree.loadKey();
                                                    this.setState({
                                                        deptVisible: true
                                                    })
                                                }
                                            }}>
                                    </Select>
                                    {this.props.isSys === "true" ?
                                        <Icon width={12} height={12} style={{
                                            position: "absolute",
                                            top: 10,
                                            right: 10,
                                            color: "rgba(0, 0, 0, 0.25)"
                                        }} type="right"/> : null}
                                </Col>
                            </div>
                        </Row>
                        <Row>
                            <div style={{padding: 10}}>
                                <Col span={3}>
                                    <div className={'myMediaTitle'}>媒体描述：</div>
                                </Col>
                                <Col span={20}>
                                    <TextArea placeholder={"请输入对于此媒体的描述，限制输入200个字符"}
                                              className={'mediaAdministerContent'}
                                              value={this.state.description}
                                              maxLength={200}
                                              style={{resize: "none"}}
                                              autoSize={{minRows: 5, maxRows: 5}}
                                              onChange={(e) => {
                                                  this.setState({description: e.target.value.trim()})
                                              }}/>
                                </Col>
                            </div>
                        </Row>
                        <Row>
                            <div style={{padding: "20px 10px 10px 10px"}}>
                                <Col span={3}>
                                    <div className={'myMediaTitle'}>媒体logo：</div>
                                </Col>
                                <Col span={20}>
                                    <div style={{position: 'relative'}} id={"uploadLogo"}>
                                        <Upload {...upload}>
                                            <div>
                                                {
                                                    this.state.mediaLogo ?
                                                        <img src={this.state.mediaLogo} alt="avatar" style={{
                                                            width: '56px',
                                                            height: '56px',
                                                            objectFit: 'cover'
                                                        }}/> : uploadButton
                                                }
                                            </div>
                                        </Upload>
                                        {
                                            this.state.mediaLogo ?
                                                <div style={{position: "absolute", top: 56, left: 86}}>
                                                    <Upload {...upload} listType={""}>
                                                        <div style={{
                                                            color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                                            cursor: "pointer"
                                                        }}>重新上传
                                                        </div>
                                                    </Upload>
                                                    <span style={{
                                                        marginLeft: "10px",
                                                        color: "rgba(0, 0, 0, 0.45)",
                                                        cursor: "pointer"
                                                    }} onClick={() => {
                                                        this.state.mediaLogo = "";
                                                        this.setState({});
                                                    }}>删除</span>
                                                </div>
                                                : null
                                        }
                                    </div>
                                    <style>{`
                                    #uploadLogo .ant-upload.ant-upload-select-picture-card{width: 70px;height: 70px}
                                    #uploadLogo .ant-upload.ant-upload-select-picture-card > .ant-upload{padding: 0;}
                                    `}</style>
                                </Col>
                            </div>
                        </Row>
                        <Row>
                            <div style={{padding: 10, position: "relative"}} id={"bindManager"}>
                                <Col span={3}>
                                    <div className={'myMediaTitle'}>绑定管理员：
                                    </div>
                                </Col>
                                <Col span={20}>
                                    <Select className={'mediaAdministerContent'}
                                            mode={"multiple"}
                                            placeholder={"请选择"}
                                            value={accountNames}
                                            style={{width: '100%'}}
                                            open={false}
                                            showArrow={false}
                                            onDeselect={(value) => {
                                                this.state.newData.length && this.state.newData.forEach((item, index) => {
                                                    if (item.name === value) {
                                                        this.state.newData.splice(index, 1);
                                                    }
                                                });
                                                this.setState({});
                                            }}
                                            onDropdownVisibleChange={() => {
                                                this.setState({bindUsers: false}, () => {
                                                    if (this.state.deptName.length === 0) {
                                                        message.warn("请先选择所属部门！");
                                                    } else {
                                                        this.selectManager();
                                                    }
                                                })

                                            }}>
                                    </Select>
                                    <Icon width={12} height={12} style={{
                                        position: "absolute",
                                        top: 10,
                                        right: 10,
                                        color: "rgba(0, 0, 0, 0.25)"
                                    }} type="right"/>
                                    <style>{`
                                    #bindManager .ant-select-selection--multiple{cursor: pointer;}
                                    #bindManager .ant-select-selection--multiple .ant-select-selection__choice{max-width: 97%;}
                                    `}</style>
                                </Col>
                            </div>
                        </Row>
                        <Row>
                            <div style={{padding: 10}}>
                                <Col span={3}>
                                    <div className={'myMediaTitle'}><span
                                        style={{color: 'red', position: 'absolute', top: 3, left: 10}}>*</span>媒体排序：
                                    </div>
                                </Col>
                                <Col span={20}>
                                    <InputNumber
                                        placeholder={"请输入"}
                                        value={this.state.sort}
                                        min={0}
                                        onChange={(sort) => {
                                            this.setState({sort})
                                        }}
                                    />
                                    <style>{`.ant-input{border: 1px solid #EEF2FB;}`}</style>
                                </Col>
                            </div>
                        </Row>
                    </div>
                </Modal>
                {/*选择管理员弹窗*/}
                <Modal
                    title={"选择管理员"}
                    visible={this.state.managerVisible}
                    width={800}
                    zIndex={1000}
                    onCancel={() => {
                        this.setState({
                            loadKey: uuid(),
                            managerVisible: false,
                            keywords: ''
                        })
                    }}

                    className={"selectManager"}
                    maskClosable={false}
                    key={this.state.loadKey}
                    footer={
                        <div style={{display: "flex", alignItems: "center"}}>
                            <div style={{display: "flex", alignItems: "center"}}>
                                <div style={{width:'84px'}}>{this.state.bindUsers?'':'当前管理员:'}</div>
                                <div style={{
                                    width: 200, overflow: "hidden", textOverflow: "ellipsis",
                                    whiteSpace: "nowrap", textAlign: "left"
                                }} title={accountNames.join("，")}>{this.state.bindUsers?'':accountNames.join("，")}</div>
                            </div>

                            <div style={{margin: "0px 20px"}}>
                                <Button onClick={() => {
                                    this.setState({
                                        loadKey: uuid(),
                                        managerVisible: false,
                                        keywords: ''
                                    })
                                }}>取消</Button>
                            </div>
                            <div>
                                <Button type={"primary"} onClick={() => {
                                    this.onManagerOk()
                                }}>确定</Button>
                            </div>
                        </div>
                    }
                >
                    <div style={{
                        width: "100%",
                        height: this.state.hideOnSinglePage ? "290px" : "335px",
                        padding: "0px 20px"
                    }} id={"selectManager"}>
                        <style>{`.selectManager .ant-modal-body{padding: 10px 20px 20px 20px}`}</style>
                        <Search placeholder={"请输入姓名或账号"} value={this.state.keywords}
                                style={{width: 270, marginBottom: 10}}
                                onSearch={(keywords) => {
                                    this.setState({keywords, page: 1}, () => {
                                        if (this.state.bindUsers) {
                                            this.getNewDeptUser();
                                        } else {
                                            this.getDeptUser(this.state.deptId);
                                        }

                                    })
                                }}
                                onChange={(e) => {
                                    this.state.keywords = e.target.value;
                                    this.setState({})
                                }}
                        />
                        <div id={"selectManagerTab"}>
                            <ScrollBars ref={(ref) => this.scrollBars = ref} autoHide autoHeight autoHeightMax={260}>
                                <Table rowKey={(record) => record.id} columns={columns} dataSource={this.state.deptUserList}
                                       pagination={false}/>
                            </ScrollBars>
                            <style>{`#selectManagerTab .ant-table-row:nth-child(2n) {background-color: rgba(245, 248, 252, 1);}
                                    #selectManagerTab .ant-empty-normal{margin: 64px 0px 0px 0px;}
                                    #selectManagerTab .ant-table-placeholder{border-bottom: 0;}
                                    `}</style>
                        </div>
                        <Divider
                            style={{display: (this.state.hideOnSinglePage || !this.state.deptUserList.length) ? "none" : "block"}}/>
                        <style>{`#selectManager .ant-divider-horizontal{margin: 0px 0px 10px 0px;}`}</style>
                        <div style={{
                            paddingBottom: this.state.hideOnSinglePage ? "0px" : "20px",
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center"
                        }}>
                            {this.state.deptUserList.length>0? <Pagination {...pagination}/>:null}

                        </div>
                    </div>
                </Modal>
                {/*选择部门弹窗*/}
                <DeptTree
                    deptVisible={this.state.deptVisible}
                    departAllList={this.props.departAllList}
                    checkedNodeKey={[this.state.deptId]}
                    checkedNodeName={this.state.deptName}
                    onCancelChecked={() => {
                        this.setState({
                            deptVisible: false
                        })
                    }}
                    onOkCheck={(checkedNodeKey, checkedNodeName) => {
                        this.checkedNode(checkedNodeKey, checkedNodeName);
                    }}
                    showSearch={this.props.isSys === 'true'}
                    ref={(c) => this.deptTree = c}
                /><SelectUserModal ref={ref => this.selectUserModal = ref} isBindUser={true}/>
            </div>
        )
    }

    selectManager() {

        this.state.page = 1;
        this.state.size = 10;
        this.state.keywords = "";
        this.state.managerVisible = true;
        this.state.useDeptUserList = JSON.parse(JSON.stringify(this.state.newData));
        if (this.state.bindUsers) {
            this.getNewDeptUser();
        } else {
            this.getDeptUser(this.state.deptId);
        }

    }

    getNewDeptUser() {
        let params = {
            page: this.state.page,
            size: this.state.size,
            mediaId: this.state.currentMedia.id
        };
        if (this.state.keywords) {
            params.accountOrName = this.state.keywords;
        }
        getDeptUser(params, (res) => {
            let deptUserList = [];
            let total = 0;
            if (res.data.length > 0) {
                deptUserList = res.data;
                total = res.count;
            }
            this.setState({
                deptUserList,
                total
            }, () => {
                $('.ant-pagination-options-quick-jumper').find("input").val("");
            });
        });

    }

    saveMedia() {
        //校验
        if (!this.state.name) {
            message.warn("请填写媒体名称！");
            return;
        }
        if (!this.state.mediaTypeCode) {
            message.warn("请选择媒体类型！");
            return;
        }
        if (this.state.mediaTypeCode === "rmapp" && !this.state.rmType && this.state.rmType !== 0) {
            message.warn("请选择融媒号类型！");
            return;
        }
        if (this.state.deptName.length === 0) {
            message.warn("请选择所属部门！");
            return;
        }
        if (!this.state.sort && this.state.sort !== 0) {
            message.warn("请填写媒体排序！");
            return;
        }
        let reg = /^[0-9]*$/;
        if (!reg.test(this.state.sort)) {
            message.warn("只能输入数字！");
            return;
        }
        //保存
        if ((this.state.mediaTypeCode === "webNews" || this.state.mediaTypeCode === "material" || this.state.mediaTypeCode === "baijiahao") && !this.state.id) {
            this.props.onCancelAdd();
            this.saveData((item) => {
                this.props.openInfoVisible(this.state.mediaTypeCode, this.state.name, this.state.mediaLogo, item);
            });
        } else {
            this.saveData();
        }
    }

    sortVerify(deptId) {
        let params = {
            deptId: deptId
        };
        getMediaSortData(params, (data) => {
            if (!data && data !== 0) {
                this.setState({
                    sort: ""
                })
            } else {
                this.setState({
                    sort: data + 1
                })
            }
        })
    }

    saveData(callback) {
        let userIds = [];
        this.state.newData && this.state.newData.length > 0 && this.state.newData.forEach(item => {
            userIds.push(item.id);
        })
        let mediaLogo = this.state.mediaLogo;
        if (!mediaLogo && this.state.mediaTypeCode === "rmapp") {
            if (this.state.rmType === 0) {
                mediaLogo = "images/rm/defaultType1.png";
            } else {
                mediaLogo = "images/rm/defaultType2.png";
            }
        }
        let params = {
            name: this.state.name,
            mediaTypeCode: this.state.mediaTypeCode,
            deptId: this.state.deptId,
            description: this.state.description,
            mediaLogo: mediaLogo,
            userIds: userIds,
            sort: this.state.sort
        }
        if (this.state.rmType || this.state.rmType === 0) {
            params.rmType = this.state.rmType;
        }
        //单个新增更新
        if (this.state.id) {
            params.id = this.state.id;
            mediaAdministerUpdate(params, (data, status) => {
                if (status === 200) {
                    this.state.id = params.id;
                    this.setState({});
                    message.success("修改成功！");
                    this.props.onCancelAdd();
                    this.props.getMediaAdminister();
                }
            })
        } else {
            mediaAdministerAdd(params, (data, status) => {
                if (status === 200) {
                    this.state.id = data.id;
                    if (callback) {
                        callback(data);
                    }
                    this.setState({});
                    message.success("新增成功！");
                    this.props.onCancelAdd();
                    this.props.getMediaAdminister();
                }
            })
        }
    }

    onManagerOk() {
        this.state.newData = JSON.parse(JSON.stringify(this.state.useDeptUserList));
        this.setState({
            managerVisible: false,
            keywords: ''
        })
    }

    checkedNode(checkedNodeKey, checkedNodeName) {
        let deptId = checkedNodeKey[0];
        let deptName = checkedNodeName;
        if (deptId !== this.state.deptId) {
            this.state.sort = "";
            this.state.newData = [];
        }
        this.setState({
            deptId,
            deptName,
            deptVisible: false
        }, () => {
            if (!this.state.sort && this.state.sort !== 0 && deptId) {
                this.sortVerify(deptId);
            }
        })
    }

    revert() {
        this.setState({
            loading: false,
            id: "",
            name: "", //媒体名称
            mediaTypeCode: undefined, //媒体类型
            rmType: 0,
            deptId: window.top.currentUser.deptIds[0],
            deptName: [window.top.currentUser.deptList[0].name], //所属部门
            description: "", //媒体描述
            mediaLogo: "", //媒体logo
            sort: "", //媒体排序
            page: 1,
            size: 10,
            newData: this.props.isSys ? [] : [window.top.currentUser]
        })
    }
}